import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";

const TITLE = "Kalkulator Ulang Tahun Pernikahan - Hitung Durasi Pernikahan dan Tanggal Ulang Tahun Berikutnya";
const DESCRIPTION = "Hitung durasi pernikahan Anda dalam tahun, bulan, dan hari secara akurat, dan ketahui tanggal ulang tahun pernikahan Anda berikutnya. Alat lengkap yang menawarkan saran hadiah ulang tahun sesuai dengan tradisi dan tren modern.";
const KEYWORDS = "kalkulator ulang tahun pernikahan, hitung durasi pernikahan, tanggal ulang tahun pernikahan, hadiah ulang tahun pernikahan, kalkulator hubungan, kalkulator kenangan";
const OG_URL = "https://do-calculate.com/calculator/id/wedding-anniversary-calculator/";

const ANNIVERSARY_GIFTS = {
  1: "Hadiah kertas (atau jam modern)",
  2: "Hadiah katun (atau porselen)",
  3: "Hadiah kulit (atau kaca)",
  4: "Hadiah buah/bunga (atau peralatan elektronik)",
  5: "Hadiah kayu (atau perak)",
  10: "Hadiah timah/aluminium (atau berlian)",
  15: "Hadiah kristal",
  20: "Hadiah porselen",
  25: "Hadiah perak",
  30: "Hadiah mutiara",
  40: "Hadiah rubi",
  50: "Hadiah emas",
  60: "Hadiah berlian"
};

const GREGORIAN_MONTHS = [
  "Januari", "Februari", "Maret", "April",
  "Mei", "Juni", "Juli", "Agustus",
  "September", "Oktober", "November", "Desember"
];
function Calculator() {
  const [weddingDateState, setWeddingDateState] = useState({
    day: "1",
    month: "1",
    year: "2020"
  });
  const [results, setResults] = useState(null);
  const [error, setError] = useState("");

  const calculateAnniversary = () => {
    const wedding = new Date(
      parseInt(weddingDateState.year),
      parseInt(weddingDateState.month) - 1,
      parseInt(weddingDateState.day)
    );
    const today = new Date();

    if (isNaN(wedding.getTime())) {
      setError("Harap masukkan tanggal pernikahan dengan benar");
      setResults(null);
      return;
    }

    if (wedding > today) {
      setError("Tanggal pernikahan tidak boleh di masa depan");
      setResults(null);
      return;
    }

    const timeDiff = Math.abs(today - wedding);
    const diffInDays = Math.floor(timeDiff / (1000 * 3600 * 24));
    const diffInMonths = Math.floor(diffInDays / 30.436875);
    const diffInYears = Math.floor(diffInDays / 365.25);

    const nextAnniversary = new Date(wedding);
    nextAnniversary.setFullYear(today.getFullYear());

    if (nextAnniversary < today) {
      nextAnniversary.setFullYear(today.getFullYear() + 1);
    }

    const daysToNextAnniversary = Math.floor((nextAnniversary - today) / (1000 * 3600 * 24));
    const nextYear = diffInYears + 1;
    const traditionalGift = ANNIVERSARY_GIFTS[nextYear] || "Anda dapat memilih hadiah khusus Anda sendiri";
    const currentGift = ANNIVERSARY_GIFTS[diffInYears] || "Anda dapat memilih hadiah khusus Anda sendiri";

    setResults({
      years: diffInYears,
      months: diffInMonths % 12,
      days: diffInDays % 365,
      nextAnniversary: nextAnniversary.toLocaleDateString('id-ID'),
      daysToNextAnniversary,
      traditionalGift,
      currentGift
    });
    setError("");
  };

  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ height: "50px" }}>
            <h1 style={{ fontSize: "17px", lineHeight: "50px", margin: 0 }}>{TITLE}</h1>
          </div>
          <div className="border border-light p-3">
            <div className="row">
              <div>
                <p>
                  Apakah Anda bertanya-tanya sudah berapa tahun sejak pernikahan Anda? Kalkulator ulang tahun pernikahan adalah alat gratis dan mudah digunakan yang menghitung untuk Anda
                  durasi pernikahan Anda secara akurat dalam tahun, bulan, dan hari, dan memberi tahu Anda tentang tanggal ulang tahun pernikahan Anda berikutnya dan berapa hari
                  tersisa untuk itu. Kalkulator ini juga memberikan saran untuk hadiah ulang tahun pernikahan terbaik yang sesuai untuk setiap tahap
                  sesuai dengan adat tradisional dan tren modern.
                </p>
                <p>Cara menggunakan kalkulator ulang tahun pernikahan:</p>
                <ul>
                  <li>Pilih hari, bulan, dan tahun pernikahan dari menu di bawah ini</li>
                  <li>Tekan tombol "Hitung" untuk mendapatkan hasil secara instan</li>
                  <li>Anda akan melihat durasi pernikahan Anda secara detail, tanggal ulang tahun Anda berikutnya, dan saran hadiah yang sesuai</li>
                </ul>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-12 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px", margin: 0 }}>{TITLE}</h2>
                </div>
                <hr />
                <div >
                  <div className="form-group d-flex align-items-center flex-wrap gap-2">
                    <b>
                      <label className="form-label ms-2 mb-0">Tanggal Pernikahan</label>
                    </b>
                    <div className="d-flex gap-2">
                      <select
                        className="form-control"
                        style={{ width: "80px" }}
                        value={weddingDateState.day}
                        onChange={(e) => setWeddingDateState({ ...weddingDateState, day: e.target.value })}
                      >
                        {Array.from({ length: 31 }, (_, i) => i + 1).map(d => (
                          <option key={d} value={d}>{d}</option>
                        ))}
                      </select>
                      <select
                        className="form-control"
                        style={{ width: "180px" }}
                        value={weddingDateState.month}
                        onChange={(e) => setWeddingDateState({ ...weddingDateState, month: e.target.value })}
                      >
                        {GREGORIAN_MONTHS.map((m, i) => (
                          <option key={i + 1} value={i + 1}>{i + 1} - {m}</option>
                        ))}
                      </select>
                      <select
                        className="form-control"
                        style={{ width: "100px" }}
                        value={weddingDateState.year}
                        onChange={(e) => setWeddingDateState({ ...weddingDateState, year: e.target.value })}
                      >
                        {Array.from({ length: 100 }, (_, i) => new Date().getFullYear() - i).map(y => (
                          <option key={y} value={y}>{y}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <br />
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px" }}
                    onClick={calculateAnniversary}
                  >
                    Hitung
                  </button>
                </div>
                <br />
                <div>
                  { error !== "" ? (
                    <p className="p-3 mb-2 bg-warning text-white">
                      Kesalahan: {error}
                    </p>
                  ) : (
                    <>
                      { results && (
                        <>
                          <p className="p-3 mb-2 bg-info">
                            Durasi pernikahan Anda: {results.years} tahun {results.months} bulan {results.days} hari
                          </p>
                          <p className="p-3 mb-2 bg-info">
                            Ulang tahun pernikahan Anda berikutnya: {results.nextAnniversary} (dalam {results.daysToNextAnniversary} hari)
                          </p>
                          <p className="p-3 mb-2 bg-info">
                            Tahun ini Anda merayakan ulang tahun pernikahan ke: {results.years + 1}
                          </p>
                          <p className="p-3 mb-2 bg-info">
                            Saran hadiah untuk ulang tahun berikutnya: {results.traditionalGift}
                          </p>
                          <p className="p-3 mb-2 bg-info">
                            Hadiah ulang tahun saat ini: {results.currentGift}
                          </p>
                          <p className="p-3 mb-2 bg-info">
                            Selamat! Anda telah menghabiskan bersama {Math.floor(results.months + (results.years * 12))} bulan dan {results.days} hari penuh cinta dan pengertian
                          </p>
                        </>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <div className="col-12 col-md-8">
        <div className="info-sections-container">

          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>
                Kalkulator Ulang Tahun Pernikahan - Hitung Berapa Tahun Sudah Berlalu Sejak Pernikahan Anda
              </h3>
            </div>
            <div className="info-section-body">
              <p>
                Kalkulator ulang tahun pernikahan adalah alat digital gratis yang memungkinkan pasangan mengetahui berapa tahun dan durasi yang telah berlalu sejak pernikahan mereka secara akurat.
                Kalkulator ini bergantung pada tanggal pernikahan untuk menghitung durasi dalam tahun, bulan, dan hari, dan menentukan tanggal ulang tahun pernikahan berikutnya
                dan berapa hari tersisa untuk itu, serta memberikan saran untuk hadiah ulang tahun pernikahan yang dikenal untuk setiap tahun.
                Baik Anda mencari perayaan ulang tahun pernikahan pertama Anda atau ulang tahun emas kelima puluh, Anda akan menemukan semua yang Anda butuhkan di sini.
              </p>
            </div>
          </div>

          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>
                Bagaimana Cara Kerja Kalkulator Ulang Tahun Pernikahan?
              </h3>
            </div>
            <div className="info-section-body">
              <p>
                Cukup masukkan tanggal pernikahan Anda lalu tekan "Hitung", dan Anda akan langsung mendapatkan hasil berikut:
              </p>
              <ul>
                <li><strong>Durasi Pernikahan</strong>: dalam tahun, bulan, dan hari sejak hari pernikahan hingga hari ini</li>
                <li><strong>Tanggal Ulang Tahun Berikutnya</strong>: tanggal pasti ulang tahun pernikahan Anda tahun ini atau tahun depan</li>
                <li><strong>Hitungan Mundur</strong>: jumlah hari tersisa hingga ulang tahun pernikahan Anda tiba</li>
                <li><strong>Hadiah Ulang Tahun</strong>: saran tradisional dan modern yang sesuai untuk setiap tahun</li>
              </ul>
            </div>
          </div>

          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>
                Apa Hadiah Ulang Tahun Pernikahan yang Sesuai untuk Setiap Tahun?
              </h3>
            </div>
            <div className="info-section-body">
              <p>
                Setiap ulang tahun pernikahan memiliki hadiah tradisional yang dikenal di banyak negara di dunia, mencerminkan kedalaman hubungan dan perkembangannya selama bertahun-tahun:
              </p>
              <ul>
                <li><strong>Ulang Tahun Pertama:</strong> Hadiah kertas atau jam — simbol awal dari kisah hidup bersama</li>
                <li><strong>Ulang Tahun Kelima:</strong> Hadiah kayu atau perak — simbol kekuatan dan keteguhan</li>
                <li><strong>Ulang Tahun Kesepuluh:</strong> Hadiah timah atau aluminium — simbol fleksibilitas dan ketahanan</li>
                <li><strong>Ulang Tahun Kelima Belas:</strong> Hadiah kristal — simbol kejernihan dan transparansi</li>
                <li><strong>Ulang Tahun Perak (25 tahun):</strong> Hadiah perak — penghormatan untuk seperempat abad cinta</li>
                <li><strong>Ulang Tahun Emas (50 tahun):</strong> Hadiah emas — puncak kesetiaan dan pengabdian</li>
                <li><strong>Ulang Tahun Berlian (60 tahun):</strong> Hadiah berlian — yang paling berharga yang dapat diberikan</li>
              </ul>
              <p>
                Rayakan setiap ulang tahun pernikahan dengan cara yang istimewa sesuai dengan perjalanan bersama Anda. Gunakan kalkulator ulang tahun pernikahan untuk mengetahui
                hadiah ideal yang sesuai dengan tahun pernikahan Anda dengan tepat.
              </p>
            </div>
          </div>

          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>
                Pertanyaan Umum tentang Menghitung Ulang Tahun Pernikahan
              </h3>
            </div>
            <div className="info-section-body">
              <p>
                <strong>Bagaimana cara menghitung berapa tahun sudah berlalu sejak pernikahan saya?</strong><br />
                Masukkan tanggal pernikahan Anda ke dalam kalkulator ulang tahun pernikahan di atas dan tekan "Hitung", Anda akan menemukan durasi lengkap dalam tahun, bulan, dan hari.
              </p>
              <p>
                <strong>Kapan ulang tahun pernikahan emas dirayakan?</strong><br />
                Ulang tahun pernikahan emas dirayakan setelah 50 tahun penuh berlalu sejak hari pernikahan, dan ini adalah salah satu momen terbesar dalam kehidupan pasangan.
              </p>
              <p>
                <strong>Apa perbedaan antara ulang tahun perak dan emas?</strong><br />
                Ulang tahun perak jatuh pada tahun kedua puluh lima pernikahan, sedangkan ulang tahun emas jatuh pada tahun kelima puluh.
              </p>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}
export default Calculator;